import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, gbp, fmtDate, ACCESS_LABEL, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user, logout, refreshUser } = useAuth();
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const load = () => api.get("/account").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const cancel = async () => {
    if (!window.confirm("Cancel at the end of your current billing period?")) return;
    try { await api.post("/account/cancel"); toast.success("Your subscription will end at the close of this billing period."); load(); refreshUser(); } catch (e) { toast.error(formatApiError(e)); }
  };
  if (!data) return <div className="min-h-[60vh]" />;
  const u = data.user;

  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-10 py-14 lg:py-20" data-testid="account-page">
      <p className="overline text-[#E5332A]">My account</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold mt-3">Hello, {u.name || user.email}.</h1>
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        <div className="md:col-span-2 bg-[#0A0A0A] text-white p-8 relative grain">
          <div className="relative">
            <p className="overline text-[#E5332A]">Membership</p>
            <p className="font-display text-4xl font-bold mt-3" data-testid="account-tier">{ACCESS_LABEL[u.tier] === "Free" ? "Reader (Free)" : ACCESS_LABEL[u.tier]}</p>
            {u.billing && <p className="text-sm text-[#E7E7E7]/70 mt-2" data-testid="account-billing">Billed {u.billing} · {u.subscription_status}</p>}
            <div className="flex flex-wrap gap-3 mt-8">
              {u.tier !== "institutional" && <Link to="/pricing" data-testid="account-upgrade-btn" className="bg-[#E5332A] text-white px-5 py-2.5 text-sm font-medium">Upgrade plan</Link>}
              {u.stripe_subscription_id && u.subscription_status === "active" && <button onClick={cancel} data-testid="account-cancel-btn" className="border border-white/30 px-5 py-2.5 text-sm hover:bg-white/10">Cancel subscription</button>}
            </div>
          </div>
        </div>
        <div className="border border-[#E7E7E7] bg-white p-8">
          <p className="overline text-[#575757]">Reports owned</p>
          <p className="font-display text-4xl font-bold mt-3" data-testid="account-reports-count">{u.tier === "institutional" ? "All" : u.purchased_reports.length}</p>
          <Link to="/research" className="text-sm text-[#E5332A] link-underline mt-4 inline-block">Research store</Link>
        </div>
      </div>
      <h2 className="font-display text-2xl font-bold mt-16 border-b border-[#E7E7E7] pb-3">Payment history</h2>
      {data.transactions.length === 0 ? <p className="text-sm text-[#575757] py-6">No payments yet.</p> : (
        <table className="w-full text-sm mt-2" data-testid="account-transactions">
          <tbody>
            {data.transactions.map((t) => (
              <tr key={t.session_id} className="border-b border-[#E7E7E7]">
                <td className="py-3">{fmtDate(t.created_at)}</td><td className="capitalize">{t.lookup_key.replace(/_/g, " ")}</td>
                <td className="font-mono-d">{gbp(t.amount, 2)}</td><td className={t.payment_status === "paid" ? "text-[#0A0A0A]" : "text-[#575757]"}>{t.payment_status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <button onClick={async () => { await logout(); navigate("/"); }} data-testid="logout-btn" className="mt-12 text-sm text-[#575757] hover:text-[#E5332A] link-underline">Sign out</button>
    </div>
  );
}
